if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      

      onSubmitHandler(evt) {
        // Prevenir comportamiento predeterminado y propagación
        if (evt.cancelable) {
          evt.preventDefault();
        }
        evt.stopPropagation();
        evt.stopImmediatePropagation(); 
        
        // Si el botón está deshabilitado, no hacer nada
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Limpiar mensajes de error anteriores
        this.handleErrorMessage();
        const alertElement = this.form.querySelector('[data-alert-event]');
        if (alertElement) {
          alertElement.textContent = '';
          alertElement.classList.remove('error-message');
          alertElement.classList.add('hidden'); // Ocultar el elemento de alerta
        }

        // Actualizar UI para mostrar estado de carga
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        // Preparar configuración para la solicitud fetch
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Preparar datos del formulario
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Realizar la solicitud fetch
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            this.querySelector('button-pdp')?.initButtons();

            // Manejar respuesta con error (status truthy indica error)
            if (response.status) {
              // Mostrar mensaje de error
              const errorMessage = response.description || response.message || 'Error al añadir al carrito';
              this.handleErrorMessage(errorMessage);
              
              // Manejar mensaje de agotado si existe
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
              }
              return;
            } 
            window.showToast(window.globalTranslations.addToCart);
            // Manejar redirección si no hay carrito
            if (!this.cart) {
              /* window.location = window.routes.cart_url; */
              return;
            }

            // Éxito: actualizar el carrito
            this.error = false;
            
            // Manejar modal de añadir rápido si existe
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              // Renderizar contenidos del carrito directamente
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {

            // Mostrar mensaje de error genérico
            const alertElement = this.form.querySelector('[data-alert-event]');
            if (alertElement) {
              alertElement.textContent = 'Error al procesar la solicitud. Por favor, inténtalo de nuevo.';
              alertElement.classList.add('error-message');
              alertElement.classList.remove('hidden');
            }
          })
          .finally(() => {
            // Restaurar estado de UI
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            //this.querySelector('.loading__spinner').classList.add('hidden');

            console.log('CART:REFRESH 2')
            const variantId = this.form.querySelector('[name="id"]').value;
            document.dispatchEvent(new CustomEvent('cart:refresh', {detail: {variantId}}));         
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
    
  );
}

if (!customElements.get('product-form')) {
  customElements.define(
    'custom-product-form',
    class CustomProductForm extends HTMLElement {
      constructor() {
        super();
        
      }
    }
  );
}
